import { render } from "./WorkCard.vue?vue&type=template&id=032a4c3d&scoped=true"
import script from "./WorkCard.vue?vue&type=script&lang=js"
export * from "./WorkCard.vue?vue&type=script&lang=js"

import "./WorkCard.vue?vue&type=style&index=0&id=032a4c3d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032a4c3d"]])

export default __exports__